import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material
import {
  Card,
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TableHead,
  CircularProgress,
  Icon,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Dialog,
  Divider,
  Avatar,
  IconButton,
  Autocomplete,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import Moment from 'moment';
import { Box } from '@mui/system';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// components
import { EditRounded, RemoveRedEyeRounded } from '@mui/icons-material';
import axios from 'axios';
import UserPopup from '../components/UserPopup';
import Page from '../components/Page';
import Scrollbar from '../components/Scrollbar';
import Popup from '../components/PopUp';
// mock
import Filter from '../components/filters/ClientFilter';
import Iconify from '../components/Iconify';

import { commonHeadStyle, commonBodyStyle } from '../theme/commonStyles';
import AddLead from '../components/AddLead';

// import { FilterForm } from '../components/FilterForm';

// ----------------------------------------------------------------------

// const customToolBar = ({setFilter})
export default function Lead() {
  const navigate = useNavigate();
  const [userData, setUserData] = useState();
  const [pages, setPages] = useState(0);
  const [userCount, setUserCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState();
  const size = 10;
  const [options, setOptions] = useState({ size, page: 0 });
  const [input, setInput] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [editUserPopup, setEditUserPopup] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [leadStatuses, setLeadStatuses] = useState([]);

  const getLeads = (options) => {
    console.log(options);
    setIsLoading(true);
    axios
      .get(`${process.env.REACT_APP_API_URL}/lead/admin/all`, {
        params: options,
      })
      .then((res) => {
        console.log('ressssssssssss', res);
        if (res.data.isError === false) {
          setUserCount(res.data.data.maxRecords);
          setUserData(res.data.data.records);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsLoading(false);
      });
  };

  const getLeadStatuses = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/leadStatus/admin/all/list`);
      setLeadStatuses(response.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddModal = () => {
    setOpenModal(!openModal);
  };

  const handlePageChange = (event, newPage) => {
    setPages(newPage);
    const temp = { ...options, page: newPage };
    setOptions(temp);
    getLeads(temp);
  };

  const applyFilters = (filter) => {
    console.log('filter', filter);
    const temp = { page: 0, size };
    if (filter.userId.length) {
      temp.userId = filter.userId;
    }
    if (filter.name.trim()) {
      temp.name = filter.name.trim();
    }
    if (filter.email.length) {
      temp.email = filter.email;
    }
    if (filter.startDate.length) {
      temp.startDate = filter.startDate;
    }
    if (filter.endDate.length) {
      temp.endDate = filter.endDate;
    }
    if (filter.role.length) {
      temp.role = filter.role;
    }
    if (filter.isBlocked) {
      temp.isBlocked = filter.isBlocked;
    }
    setOptions(temp);
    setPages(0);
    getLeads(temp);
  };

  const goToPage = () => {
    if (input > Math.ceil(userCount / size)) {
      return;
    }
    setInput(input > 0 ? input : 1);
    setPages(input - 1 >= 0 ? input - 1 : 0);
    const temp = { ...options, page: input - 1 };
    setOptions(temp);
    getLeads(temp);
  };

  useEffect(() => {
    getLeads(options);
    getLeadStatuses();
  }, []);


  const updateStatus = (item, value) => {
    const requestBody = {
      id: item._id,
      status: value._id,
    };

    axios
      .put(`${process.env.REACT_APP_API_URL}/lead/admin`, requestBody)
      .then((res) => {
        handleClose(true, res.data.message);
      })
      .catch((err) => {
        handleClose(false, err.response.data.message);
      });
  };


  const handleClose = (refresh = false, message = '') => {
    if (refresh) {
      getLeads(options);
    }
    if (message) {
      toast(message);
    }
  };

  return (
    <>
      <Page title="Leads">
        {isLoading ? (
          <div
            style={{
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '50vh',
            }}
          >
            <CircularProgress />
          </div>
        ) : (
          <>
            <ToastContainer />
            <Container maxWidth="xl">
              <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography
                  sx={{
                    color: '#0B132B',
                    lineHeight: 'normal',
                    letterSpacing: '-0.1px',
                  }}
                  variant="headMain"
                  component={'p'}
                >
                  Leads
                </Typography>

                <Dialog open={openModal} onClose={handleAddModal}>
                  <UserPopup closePopup={handleAddModal} title={'Create New Lead'}>
                    <AddLead closePopup={handleAddModal} type={'LEAD'} />
                  </UserPopup>
                </Dialog>

                <Stack direction="row" spacing={1.5}>
                  <Button variant="contained" onClick={handleAddModal} color="buttonone">
                    New Lead
                  </Button>
                </Stack>
              </Stack>
              <Card>
                <Stack direction="row" spacing={2} padding={2} justifyContent={'space-between'}>
                  <Stack direction="row" spacing={1.5}>
                    <TextField
                      size="small"
                      style={{ maxWidth: '100px' }}
                      type="number"
                      component="div"
                      label="Go to"
                      value={input}
                      onInput={(e) => setInput(e.target.value)}
                    />
                    <Button
                      variant="contained"
                      onClick={goToPage}
                      sx={{
                        backgroundColor: '#0096DB',
                        height: '40px',
                      }}
                    >
                      Go
                    </Button>
                  </Stack>
                  <Button
                    color="buttonone"
                    variant="contained"
                    onClick={() => setFilterOpen(!filterOpen)}
                    startIcon={<Iconify icon="ic:round-filter-list" />}
                  >
                    Filter
                  </Button>
                </Stack>
                <Filter applyFilters={applyFilters} open={filterOpen} setOpen={setFilterOpen} filterValues={options} />
                <Divider
                  sx={{
                    background: ' rgba(0, 0, 0, 0.50)',
                    marginBottom: '24px',
                  }}
                />
                <Scrollbar>
                  <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                      {/* <UserListHead /> */}
                      <TableHead>
                        <TableRow>
                          <TableCell sx={commonHeadStyle}>Sl No</TableCell>
                          <TableCell sx={commonHeadStyle}>Title</TableCell>
                          <TableCell sx={commonHeadStyle}>Name</TableCell>
                          <TableCell sx={commonHeadStyle}>Email</TableCell>
                          <TableCell sx={commonHeadStyle}>Phone</TableCell>
                          <TableCell sx={commonHeadStyle}>Status</TableCell>
                          <TableCell sx={commonHeadStyle} align='center'>Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {userData?.map((item, id) => (
                          <TableRow key={id}>
                            <TableCell sx={{ ...commonBodyStyle, width: '60px' }}>{pages * size + (id + 1)}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.title}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.fullname}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.email}</TableCell>
                            <TableCell sx={{ ...commonBodyStyle }}>{item.phone}</TableCell>
                            <TableCell sx={commonBodyStyle}>
                              <FormControl sx={{ minWidth: 120 }}>
                                <Autocomplete
                                  id="asynchronous-demo"
                                  fullWidth
                                  size="small"
                                  defaultValue={item.status}
                                  isOptionEqualToValue={(option, value) => option.name === value.name}
                                  getOptionLabel={(option) => option.name}
                                  options={leadStatuses}
                                  onChange={(_, value) => {
                                    if (value) {
                                      updateStatus(item, value);
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label="Status"
                                      InputProps={{
                                        ...params.InputProps,
                                        endAdornment: <>{params.InputProps.endAdornment}</>,
                                      }}
                                    />
                                  )}
                                />

                              </FormControl>
                            </TableCell>
                            <TableCell align="center">
                              <Stack direction="row" spacing={1}>
                                <Box
                                  sx={{
                                    cursor: 'pointer',
                                    background: '#52D0B3',
                                    '&:hover': {
                                      background: '#42a78f',
                                    },
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    padding: '7px',
                                    borderRadius: '10px',
                                  }}
                                  onClick={() => navigate(`/dashboard/crm/lead/view/${item._id}`)}
                                >
                                  <RemoveRedEyeRounded sx={{ color: '#fff', fontSize: '18px' }} />
                                </Box>
                              </Stack>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Scrollbar>
                <TablePagination
                  rowsPerPageOptions={[]}
                  component={'div'}
                  count={userCount}
                  onPageChange={handlePageChange}
                  rowsPerPage={rowsPerPage}
                  page={pages}
                  showFirstButton
                  showLastButton
                />
              </Card>
            </Container>
          </>
        )}
      </Page>
    </>
  );
}
